import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getDetailLinkState } from '../../utils/navigationState';

/**
 * Link to a detail page while preserving the current page (and optional tab)
 * as the return destination for back navigation.
 */
const DetailLink = ({ to, tab, state, children, ...props }) => {
  const location = useLocation();
  const linkState = state || getDetailLinkState(location, tab);

  return (
    <Link to={to} state={linkState} {...props}>
      {children}
    </Link>
  );
};

export default DetailLink;
